<template>
    <div class="chart-header-container d-flex">
        <div class="d-flex title">
            <modal-link v-if="displayModalIcon" :modal-id="contentName" :content-list="contentList"></modal-link>
            <h4 class="text-primary mt-1 mb-0">{{ title  }}</h4>
        </div>
        <div class="widgets">
            <profile-chart-buttons v-if="display" ref="chartButtons" 
              :input-display-number-of-responses="inputDisplayNumberOfResponses"
              :display-show-respondents="displayShowRespondents"
              :display-sort-by="displaySortBy"
              :display-download-comments="displayDownloadComments"
              :display-show-tooltip="displayShowTooltip"
              :input-sort-by="inputSortBy"
              :input-sort-by-options="inputSortByOptions"
              :input-show-tooltip="inputShowTooltip"
              @set-sort-by="setSortBy"
              @download-comments="downloadComments"
              @set-display-number-of-responses="setDisplayNumberOfResponses"
              @set-show-tooltip="setShowTooltip"
            />
        </div>
    </div>
</template>

<script>
import ProfileChartButtons from "./ProfileChartButtons.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ViewMixins from "../../mixins/ViewMixins.vue";
import WordCloudService from '../../services/word.cloud.service';
import AdminService from '../../services/admin.service';
import SurveyService from '../../services/survey.service';
export default {
  name: "ProfileChartHeader",
  mixins: [ContentMixins, ViewMixins],
  components: {ProfileChartButtons},
  data() {
    return {
    };
  },
  props: {
    inputSortByOptions: {
      type: Array,
      default: function() {
        return [
          { name: SurveyService.getWTPLabel(), value: "willingnessToPay" },
          { name: "Value Gap", value: "valueGap" },
        ];
      }
    },    
    title: {
        type: String,
        default: ""
    },     
    display: {
        type: Boolean,
        default: true
    },
    inputSortBy: {
        type: String,
        default: ""
    },
    inputShowTooltip: {
        type: Boolean,
        default: true
    },
    contentList: {
        type: Array,
        default: function() {
            return [];
        }
    },
    contentName: {
        type: String,
        default: ""
    },
    inputDisplayNumberOfResponses: {
        type: Boolean,
        default: true
    },     
    displayShowRespondents: {
        type: Boolean,
        default: true
    },  
    displaySortBy: {
        type: Boolean,
        default: false
    },  
    displayShowTooltip: {
        type: Boolean,
        default: true
    },
    displayDownloadComments: {
        type: Boolean,
        default: false
    }
  },
  computed: {
    displayModalIcon: function(){
      return this.contentName !== "";
    }
  },
  mounted() {},
  created() {},
  methods: {
    downloadComments: function(){
      let params = this.$parent.getChartCriteriaParams(this.$parent.$parent.clientChart, this.$parent.$parent.$refs.chartCriteria);
      this.$root.processServerRequest("Downloading Comments");
      WordCloudService.getDownloadComments(params, this.downloadItemCallback);
    },
    getDownloadFilename() {
      return "Verbatims & Respondents - " + this.$parent.$parent.survey.name;
    },
    downloadItemCallback(response) {
      this.$root.processServerResponse();
      this.setModalLoading(false);
      const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.getDownloadFilename(); 
      link.download += ".xlsx";
      link.click();
      URL.revokeObjectURL(link.href);
      this.setModalLoading(false);
      AdminService.displaySuccessMessage({ text: "Download Complete" });
    },
    setSortBy: function(inputSortBy){
        this.$emit("set-sort-by", inputSortBy);
    },    
    setDisplayNumberOfResponses(inputDisplayNumberOfResponses){
        this.$emit("set-display-number-of-responses", inputDisplayNumberOfResponses);
    },    
    setShowTooltip(inputDisplayShowTooltip){
        this.$emit("set-show-tooltip", inputDisplayShowTooltip);
    },    
  },
  watch: {},
};
</script>
